import React, {useCallback, useEffect, useState} from 'react';
import Loading, {useLoading} from "./Loading";
import ModalWindow from "./Modal";
import {useChatTrackedState, useChatDispatch} from "./store";
import ChannelIcon from "./ChannelIcon";
import ChannelTitle from "./ChannelTitle";
import ChannelSubtitle from "./ChannelSubtitle";
import {FlexScroll, Grid, TagInputContainer, TextInformationContainer} from "./styles";
import {TagInput} from "@dspworkplace/ui";
import {FilterTagArrayType} from "./types";
import {devLog} from "../utils";

function ArchiveGroupModal() {
    const {archiveConversations, archiveGroupChannelModal} = useChatTrackedState();
    const dispatch = useChatDispatch();
    const {loading, setLoading} = useLoading();
    const [matchedArchiveChannels, setMatchedArchiveChannels] = useState<Array<any>>([]);
    const [searchFilterArchiveChannels, setSearchFilterArchiveChannels] = useState<Array<FilterTagArrayType>>([]);

    const closeModal = useCallback(
        () => {
            dispatch({type: "CLOSE_ARCHIVE_GROUP_MODAL"});
        },
        [dispatch],
    );

    const openArchiveChannel = useCallback(
        (item: any) => () => {
            if (item && item.sid) {
                setLoading(true);
                dispatch({type: 'ADD_ACTIVE_CONVERSATION', conversation: item});
                setLoading(false);
                closeModal();
            }
        },
        [closeModal, dispatch, setLoading]
    );

    const handleTagChange = useCallback(
        data => {
            devLog(data);
            let filterSearch = data.map(item => item.value);
            devLog(filterSearch);
            if (filterSearch.length === 0) return;
            let result = archiveConversations.filter(channel => {
                return filterSearch.some(item => item.indexOf(channel.friendlyName) >= 0);
            });
            setMatchedArchiveChannels(result);
        },
        [archiveConversations]
    );// 269-373-5267 - health

    useEffect(() => {
        if (archiveConversations) {
            setMatchedArchiveChannels(archiveConversations);
            let searchFilter = archiveConversations.map(item => ({name: item.friendlyName, value: item.friendlyName}));
            // @ts-ignore
            setSearchFilterArchiveChannels(searchFilter);
            setLoading(false);
        }
    }, [archiveConversations, setLoading]);

    if (!archiveGroupChannelModal) {
        return null;
    }

    if (loading) {
        return (
            <ModalWindow width={"700px"} title={"Archived Group Channels"}>
                <Loading containerHeight={"300px"} containerWidth={"100%"} imgHeight={"150px"}/>
            </ModalWindow>
        );
    }

    return (
        <ModalWindow width={"700px"} title={"Archived Group Channels"} cancelModal={closeModal}>
            <Grid templateRows={"auto auto"} rowGap={"16px"}>
                <TagInputContainer width={"658px"} templateRows={"auto"}>
                    <TagInput
                        label="Find by Group Name"
                        options={searchFilterArchiveChannels}
                        size="big"
                        onChange={handleTagChange}
                        name={'names'}
                    />
                </TagInputContainer>
                <FlexScroll height={"250px"} width="100%">
                    <Grid templateColumns={"auto auto auto"} columnGap={"8px"} rowGap={"8px"}>
                        {matchedArchiveChannels.map(item => {
                            return (
                                <Grid
                                    key={item.sid}
                                    templateColumns={"40px auto"}
                                    height={"56px"}
                                    columnGap={"8px"}
                                    padding={"4px"}
                                    border={"1px dashed #7C98B6"}
                                    width={"100%"}
                                    borderRadius={"4px"}
                                    onClick={openArchiveChannel(item)}
                                >

                                    <ChannelIcon conversation={item}
                                        // @ts-ignore
                                                 kind={item.attributes['kind']}/>
                                    <TextInformationContainer>
                                        <ChannelTitle conversation={item}
                                            // @ts-ignore
                                                      kind={item.attributes['kind']}/>
                                        <ChannelSubtitle conversation={item}
                                            // @ts-ignore
                                                         kind={item.attributes['kind']}/>
                                    </TextInformationContainer>
                                </Grid>
                            );
                        })}
                    </Grid>
                </FlexScroll>
            </Grid>
        </ModalWindow>
    );
}

export default ArchiveGroupModal;